import { defineStore } from 'pinia';
import type { IRegionList, IStateContactList, IStateContactRequest } from '@/types';

interface IState {
  regions: IRegionList[];
  stateContacts: IStateContactList[];
}

export const useStateContactStore = defineStore({
  id: "useStateContactyStore",
  state: (): IState => ({
    regions: [] as Array<IRegionList>,
    stateContacts: [] as Array<IStateContactList>,
  }),
  actions: {
    async loadRegions() {
      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/stateContact/GetRegions`);

      if (response.data) {
        this.regions = response.data.data;
      }
    },

    async loadStateContacts(searchName?: string, searchEmail?: string, searchRegionId?: number) {
      const response = await this.axiosFactory
        .withoutToken()
        .get(`/api/stateContact/GetStateContacts?searchName=${searchName}&searchEmail=${searchEmail}&searchRegionId=${searchRegionId}`);

      if (response.data) {
        this.stateContacts = response.data.data;
      }
    },

    async postStateContact(stateContact: IStateContactRequest): Promise<number> {
      return await this.axiosFactory
        .withoutToken()
        .post(`/api/stateContact/PostStateContact`, stateContact)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          console.error("Create State Contact Failed", error);
        });
    },

    async updateStateContactById(stateContact: IStateContactRequest): Promise<number> {
      return await this.axiosFactory
        .withoutToken()
        .patch(`/api/stateContact/UpdateStateContactById`, stateContact)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          console.error("Update State Contact Failed", error);
        });
    },

    async removeStateContactById(regionContactId: number): Promise<number> {
      return await this.axiosFactory
        .withoutToken()
        .delete(`/api/stateContact/DeleteStateContactById?regionContactId=${regionContactId}`)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          console.error("Delete State Contact Failed", error);
        });
    },

  }
})